import { Button, PasswordInput, Stack } from "@mantine/core";
import { FC } from "react";
import { useForm } from "@mantine/form";
import { useTranslation } from "react-i18next";
import { newPassword } from "../../api/userApi";

interface Props {
  token: string;
  setStep: (value: number) => void;
}

export const NewPasswordForm: FC<Props> = ({ setStep, token }) => {
  const { t } = useTranslation();

  const form = useForm({
    initialValues: {
      password: "",
    },
    validate: {
      password: (value: string) => {
        if (value.length < 8) {
          return t("password_validation.length_error");
        }
        if (!/[0-9]/.test(value)) {
          return t("password_validation.number_error");
        }
        if (!/[A-Z]/.test(value)) {
          return t("password_uppercase_error");
        }
        return null;
      },
    },
  });

  const handleSubmit = async (values: typeof form.values) => {
    try {
      await newPassword({ token, password: values.password });
      setStep(2);
    } catch (error: any) {
      if (error?.response?.data?.password) {
        form.setFieldError("password", error.response.data.password.join(" "));
      } else {
        form.setFieldError("password", t("something_went_wrong"));
      }
    }
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack align="stretch" justify="center" gap="24px">
        <PasswordInput
          placeholder={t("password_placeholder")}
          label={t("password_label")}
          {...form.getInputProps("password")}
        />
        <Button fullWidth type="submit">
          {t("continue_button")}
        </Button>
      </Stack>
    </form>
  );
};
